var _path, _path2, _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerUserPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 205,
    viewBox: "0 0 163 205",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.7917 137.026C97.6103 136.821 107.01 136.863 114.75 137.316C118.618 137.543 122.13 137.876 125.103 138.345C128.004 138.804 130.674 139.434 132.691 140.376C141.492 144.483 147.883 153.674 152.021 162.856C156.202 172.132 158.5 182.318 158.5 189.5V197.191L152.203 192.775C96.539 153.733 35.0677 176.443 11.2654 192.797L6.26733 196.231L5.07788 190.285C2.60516 177.921 6.63636 166.964 12.3484 158.51C18.0356 150.093 25.5842 143.839 30.9167 140.586L31.7224 140.094L32.6638 140.014C46.5543 138.843 68.1425 137.437 87.7917 137.026Z",
    fill: "#2ECE6A",
    stroke: "white",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0576 9.23047C113.585 39.9973 122.657 78.0092 122.121 112.725C121.586 147.381 111.485 179.061 102.259 197.77L101.159 200H63.6895L62.5879 197.776C15.3398 102.466 52.9202 32.4996 78.4668 9.05273L81.3486 6.4082L84.0576 9.23047Z",
    fill: "#2ECE6A",
    stroke: "white",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 104,
    r: 21,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 171,
    width: 60,
    height: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 47,
    width: 64,
    height: 15,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerUserPrograms);
export default __webpack_public_path__ + "static/media/power-user-programs.4627a9ae4be743e3a0ae34a3a27e0383.svg";
export { ForwardRef as ReactComponent };